export default __webpack_public_path__ + "media/images/55-60927adbf63e2c8d02cff14f470c46d7.jpg";